import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Contact from "../components/Contact/Contact"

const contactPage = ({ data, location }) => {
  const siteUrl = data.site.siteMetadata.canonicalUrl
  return (
    <Layout>
      <SEO 
      title="Contact Danniel Hansel" 
      description="Contact Danniel for business inquiries, project collaboration, project ideas or anything questions in general." 
      keywords={["contact Danniel", "danniel", "danniel hansel", "daniel", "danielhansel", "contact"]}
      url={`${siteUrl}${location.pathname}`} />
      <Contact />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        canonicalUrl
        image
        author {
          name
        }
        organization {
          name
          url
          logo
        }
        social {
          twitter
        }
      }
    }
  }
`

export default contactPage
